// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1sYXt","form":"styles_form__1XKfi"};